export default __webpack_public_path__ + "static/media/logo3.0e12e859.gif";